/**
 * Get initials from a name string.
 * Returns up to 2 initials from the first and last name.
 *
 * @param name The full name
 * @returns Initials (e.g., "John Doe" -> "JD")
 */
export function getInitials(name: string): string {
    if (!name) {
        return '?';
    }

    const parts = name.trim().split(/\s+/);

    if (parts.length === 1) {
        // Single word name - return first 2 characters
        const firstPart = parts[0];
        if (!firstPart) {
            return '?';
        }
        return firstPart.substring(0, 2).toUpperCase();
    }

    // Multiple words - return first letter of first and last word
    const firstPart = parts[0];
    const lastPart = parts[parts.length - 1];
    if (!firstPart || !lastPart) {
        return '?';
    }
    const firstInitial = firstPart.charAt(0);
    const lastInitial = lastPart.charAt(0);

    return (firstInitial + lastInitial).toUpperCase();
}
